import { render } from "./my-interviews.vue?vue&type=template&id=20cb0279&scoped=true"
import script from "./my-interviews.vue?vue&type=script&lang=js"
export * from "./my-interviews.vue?vue&type=script&lang=js"

import "./my-interviews.vue?vue&type=style&index=0&id=20cb0279&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cb0279"]])

export default __exports__